import { BaseService } from './base.service';

export class OperatorService extends BaseService {
    baseUrl = '/operator';
}
